import * as React from 'react'

import { Box } from '~ui/components/layout/Box'
import { Number } from '~ui/components/typography/Number/Number'
import { Text } from '~ui/components/typography/Text/Text'

type TTextProps = Pick<PropsOf<typeof Text>, 'fontSize' | 'fontStyle' | 'contrast'>

type TProps = NoChildren &
  TTextProps & {
    /**
     * allergen category numerical code
     */
    number: number
    /**
     * allergen name
     */
    nameLabel: string
    /**
     * decides if there should be a comma after the element
     */
    isLastElement?: boolean
  }

/**
 * Renders a single allergen number with allergen name as a tooltip (HTML title attribute)
 */
export const Allergen: React.FC<TProps> = ({ number, nameLabel, isLastElement, ...textProps }) => {
  return (
    <Box as={`span`} title={nameLabel} cursor={`help`}>
      <Text {...textProps}>
        <Number>{number}</Number>
        {!isLastElement && <>,&nbsp;</>}
      </Text>
    </Box>
  )
}
